import React from 'react'
import { CmsBlock } from 'lib/shared/__DEPRECATED__/CmsBlock'
import { CMS_BLOCK } from 'app/sofia/resources/constants'
import { Container } from './components/Styled'

export const LegalLinks = () => {
  return (
    <Container>
      <CmsBlock
        id={CMS_BLOCK.FOOTER_LEGAL}
      >
        {({ isFailure, content }) => {
          if (isFailure) {
            if (!process.env.REACT_APP_ENABLE_CMS_BLOCK_SAMPLE_DATA) {
              return null
            }

            return (
              <SampleData />
            )
          }
          return (
            <div
              dangerouslySetInnerHTML={{
                __html: content
              }}
            />
          )
        }}
      </CmsBlock>
    </Container>
  )
}

const SampleData = () => {
  return (
    <>
      <ul className='footer__legal'>
        <li>© 2020 Sofia & Grace, All Rights Reserved</li>
        <li><a href='/'>Terms & Conditions</a></li>
        <li><a href='/'>Privacy Policy</a></li>
      </ul>
    </>
  )
}
